export const restaurantCategoryColumns = [
  {
    Header: "Category Name",
    accessor: "name",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Created on",
    accessor: "created_at",
  },
  {
    Header: "Dishes",
    accessor: "sub_Category",
  },
  {
    Header: "Action",
    accessor: "actions",
  },
];
